import { createDevTools } from '@redux-devtools/core';
import { DockMonitor } from '@redux-devtools/dock-monitor';
//import { InspectorMonitor } from '@redux-devtools/inspector-monitor';
import { SliderMonitor } from '@redux-devtools/slider-monitor';
import { envConfig } from '@src/utils/envConfig';

const isLocal = envConfig.VITE_AVA_ENV === 'local';
const isReduxDevToolsEnabled = isLocal && import.meta.env.VITE_AVA_REDUXDEVTOOLS === 'true';
export const ReduxDevTools = isReduxDevToolsEnabled
  ? createDevTools(
      <DockMonitor
        toggleVisibilityKey="ctrl-h"
        changePositionKey="ctrl-q"
        changeMonitorKey="ctrl-e"
        defaultIsVisible={false}
      >
        {/* InspectorMonitor package is bundled as CJS and Vite does not support CJS anymore - uncomment when needing locally */}
        {/*<InspectorMonitor theme="google" />*/}
        <SliderMonitor keyboardEnabled />
      </DockMonitor>
    )
  : null;

// @ts-expect-error - 'Store' types for ReduxDevTools and Redux Toolkit are inconsistent
export const ReduxDevToolsWrapper = ({ store }) => {
  return ReduxDevTools ? <ReduxDevTools store={store} /> : null;
};
